import { useEffect, useState } from "react"

const calculateTimeAgo = (date: Date) => {
  const timeSince = Date.now() - date.getTime()
  const hoursAgo = Math.floor(timeSince / (60 * 60 * 1000))
  const minutesAgo = Math.floor(timeSince / (60 * 1000))

  if (hoursAgo >= 1) {
    return `${hoursAgo}h ago`
  }

  if (minutesAgo < 1) {
    return "just now"
  }

  return `${minutesAgo}m ago`
}

export const useTimeAgo = (date: Date): string => {
  const [timeAgo, setTimeAgo] = useState(() => calculateTimeAgo(date))

  // Update the string every minute.
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeAgo(calculateTimeAgo(date))
    }, 60_000)

    return () => clearInterval(intervalId)
  }, [date])

  return timeAgo
}
